import React from "react";
import { createRoot } from "react-dom/client";
import clarity from "@microsoft/clarity";
import App from "./App";
import "./index.css";

if (typeof window !== "undefined") {
  const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  if (clarityProjectId) {
    clarity.init(clarityProjectId);
    console.log("Clarity initialized successfully.");
  } else {
    console.warn("Microsoft Clarity: Project ID not found");
  }
}

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
